import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import bottomNav from "./components/bottomNav"
Vue.component('bottomNav', bottomNav)
import rightDrawer from "./components/rightBox"
Vue.component('rightDrawer', rightDrawer)
import pullDown from './components/pullDown.vue'
Vue.component('pullDown',pullDown)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
